module.exports = __webpack_public_path__ + "static/media/licensing.0a06d39a.svg";